import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/samsung1.jpeg";
import image2 from "./images/samsung2.jpeg" ;



const Samsung = () => {
    const mediaItems = [
        {
            type: 'image',
            src: image1
        },
        {
            type: 'image',
            src: image2
        },
        // Add local video - uncomment and add actual video file
         {
             type: 'video',
             src: require('./images/samsung.mp4')
         }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">Samsung Innovation Campus</h2>
        <span className="section__subtitle">First place winner🥇</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🎓 Successfully completed the <strong>Samsung Innovation Campus – Artificial Intelligence Course</strong> with an outstanding score of <strong>95.5/100</strong>! 🚀✨
                    </p>
                    <p className='redRadio__text'>
                        💡 The program deepened my expertise in <strong>machine learning</strong>, <strong>data science</strong>, and <strong>AI algorithms</strong> through hands-on projects and applied learning.
                    </p>
                    <p className='redRadio__text'>
                        🌍 For the <strong>Capstone Project</strong>, my team and I developed an <strong>AI-powered environmental protection system</strong> featuring:
                    </p>
                    <ul className="achievement__list">
                        <li className='redRadio__text'>✔️ Air pollution prediction & recommendations</li>
                        <li className='redRadio__text'>✔️ Water pollution detection</li>
                        <li className='redRadio__text'>✔️ Wildfire detection using computer vision</li>
                        <li className='redRadio__text'>✔️ An AI chatbot for sustainability insights</li>
                    </ul>
                    <p className='redRadio__text'>
                        🌱 This experience reinforced my passion for applying <strong>AI for good</strong> — leveraging technology to address real-world environmental challenges.
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default Samsung;
